var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59 64"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bubble_svg__cls-2{fill:#010101}.bubble_svg__cls-4{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bubble_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 32.5,
    r: 24,
    fill: "#f8edda"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bubble_svg__cls-4",
    d: "M13.1 58.5l2.8 2.7 3.5.6h9.1l2.4 1h4.5l1.6-.5.4-2.6.4-1.8 1.6-1.4v-4.7l.8-1.6.2-3.9-1.4-1.1.7-2.7-1-2.3-4.6-.4-3.2.3-.4 1.3.2 2.8.7.6h-3.8l-.2-5.6.6-3 .4-6.4-1.6-3.8-2.8-1.7-1.2 1-.4 3.7-1 2.5-2 4.6-4.6 5.1-2 .5-1.2.1.2 16.5 1.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bubble_svg__cls-4",
    d: "M6 .9L6.4 21h2.9v4.8L10 27l2-1.9 3.4-4.3 1.2.1.2 8.8v1.1l4.9.3.6-2.8v-2.8l1.5-.4 1.5.9 1.4 1 1.3 3.1v1h6.5l4.5 6h1.5l.5-1V31h2.5l.5-5.8 5.1-.2 2.9 4 2.1 2.3.9-.6-.3-5.2h3L58 6.8l-22 .7-.3-6.6H6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bubble_svg__cls-2",
    d: "M26 63h-8c-2.1 0-3.3-1.1-4.2-2-.7-.7-1.2-1-1.8-1H5v-2h7c1.4 0 2.3.8 3.1 1.6.8.8 1.5 1.4 2.9 1.4h8v2zM38 53h-5c-1.7 0-3-1.3-3-3v-2c0-1.7 1.3-3 3-3h5c1.7 0 3 1.3 3 3v2c0 1.7-1.3 3-3 3zm-5-6c-.5 0-1 .5-1 1v2c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-2c0-.5-.5-1-1-1h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bubble_svg__cls-2",
    d: "M37 47h-5c-1.7 0-3-1.3-3-3v-2c0-1.7 1.3-3 3-3h5c1.7 0 3 1.3 3 3v2c0 1.7-1.3 3-3 3zm-5-6c-.5 0-1 .5-1 1v2c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-2c0-.5-.5-1-1-1h-5zM37 59h-5c-1.7 0-3-1.3-3-3v-2c0-1.7 1.3-3 3-3h5c1.7 0 3 1.3 3 3v2c0 1.7-1.3 3-3 3zm-5-6c-.5 0-1 .5-1 1v2c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-2c0-.5-.5-1-1-1h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bubble_svg__cls-2",
    d: "M35 64h-5c-1.7 0-3-1.3-3-3v-1c0-1.7 1.3-3 3-3h5c1.7 0 3 1.3 3 3v1c0 1.7-1.3 3-3 3zm-5-5c-.5 0-1 .5-1 1v1c0 .6.5 1 1 1h5c.5 0 1-.4 1-1v-1c0-.5-.5-1-1-1h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c08d42",
    d: "M1 40h10v22H1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bubble_svg__cls-2",
    d: "M12 63H0V39h12v24zM2 61h8V41H2v20zM19.6 54.9l-.7-1.9c4.2-1.6 7.1-5.5 7.1-10.1v-5c0-.4.1-.8.3-1.3.3-.9.7-2.2.7-4.3 0-3.1-.5-4.1-1.8-5.7-.5-.7-1.3-.9-1.8-.7-.4.1-.4.5-.4.5v1.4c0 4.7-2.1 7.7-4.3 10.3l-4.2 4.8H12v-2h1.5l3.6-4.1c2.4-2.7 3.8-5.1 3.8-8.9v-1.4c0-1.1.7-2.1 1.8-2.4 1.2-.4 2.9-.1 4 1.4 1.6 2 2.2 3.4 2.2 6.9s-.5 3.9-.8 4.9c0 .3-.2.6-.2.7v5c-.1 5.4-3.4 10.1-8.5 11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bubble_svg__cls-2",
    d: "M40 38c-.6 0-1.2-.3-1.6-.8L34.5 32H29v-2h6.5l4.5 6v-6h3V15H18v3h-2v-5h29v19h-3v4c0 .9-.5 1.6-1.4 1.9-.2 0-.4.1-.7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bubble_svg__cls-2",
    d: "M35 10h2v4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bubble_svg__cls-2",
    d: "M10 28c-.2 0-.4 0-.6-.1-.8-.3-1.4-1-1.4-1.9v-4H5V0h32v7h-2V2H7v18h3v6l4.5-6H35v-3h2v5H15.5l-3.9 5.2c-.4.5-1 .8-1.6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bubble_svg__cls-2",
    d: "M54 32c-.6 0-1.2-.3-1.6-.8L48.5 26H44v-2h5.5l4.5 6v-6h3V8H27v3h-2V6h34v20h-3v4c0 .9-.5 1.6-1.4 1.9-.2 0-.4.1-.7.1zM22 32h-6v-8h2v6h4v2zM5 43h2v4H5z"
  }))));
}
export default SvgBubble;